import Cookies from 'js-cookie';
import QueryString from 'query-string';
import { AnalyticsUtils } from '../analytics/AnalyticsUtils';
import { CHANNEL, COOKIE_KEYS, DOMAIN, Referrer, SOURCE, TARGET, URL_SEARCH_PARAM, UTM_MEDIUM_VALUES, UTM_SOURCE_VALUES, } from '../utils.constant';
const PARAMS_BLACKLIST = [
    URL_SEARCH_PARAM.UTM_SOURCE,
    URL_SEARCH_PARAM.UTM_MEDIUM,
    URL_SEARCH_PARAM.UTM_CAMPAIGN,
    URL_SEARCH_PARAM.UTM_TERM,
    URL_SEARCH_PARAM.UTM_CONTENT,
    URL_SEARCH_PARAM.REFERRER,
    URL_SEARCH_PARAM.MATCH_TYPE,
    URL_SEARCH_PARAM.CREATIVE,
    URL_SEARCH_PARAM.PLACEMENT,
    URL_SEARCH_PARAM.CAMPAIGN_ID,
    URL_SEARCH_PARAM.AD_SET_ID,
    URL_SEARCH_PARAM.AD_ID,
    URL_SEARCH_PARAM.REF,
    URL_SEARCH_PARAM.GCL_ID,
    URL_SEARCH_PARAM.MS_CLK_ID,
    URL_SEARCH_PARAM.FB_CL_ID,
    URL_SEARCH_PARAM.NETWORK,
    URL_SEARCH_PARAM.DEVICE,
    URL_SEARCH_PARAM.AD_SET__NAME,
    URL_SEARCH_PARAM.AD_SET_NAME,
    URL_SEARCH_PARAM.KEYWORD,
    URL_SEARCH_PARAM.DEVICE_ID,
    URL_SEARCH_PARAM.AD_NAME,
];
function extractTransParams(urlParams) {
    return {
        offer_id: urlParams[URL_SEARCH_PARAM.OFF]?.toString(),
        click_id: urlParams[URL_SEARCH_PARAM.TRANS]?.toString(),
        partner_id: urlParams[URL_SEARCH_PARAM.REF]?.toString(),
        referrer: Referrer.TECH_FILIATE_AFFILIATE?.toString(),
        target: TARGET.TECH_FILIATE,
    };
}
function extractIRClickedParams(urlParams) {
    return {
        click_id: urlParams[URL_SEARCH_PARAM.IR_CLICKED]?.toString() || '',
        affiliate_id: urlParams[URL_SEARCH_PARAM.MP_ID]?.toString(),
        referrer: Referrer.IMPACT_AFFILIATE,
        target: TARGET.IMPACT,
    };
}
function extractRefParams(urlParams) {
    return {
        partner_id: urlParams[URL_SEARCH_PARAM.REF]?.toString(),
        target: TARGET.AFFILIATE,
        source: SOURCE.BACK_LINK,
        referrer: Referrer.AFFILIATE,
    };
}
function extractSsCidParams(urlParams) {
    return {
        source: SOURCE.BACK_LINK,
        partner_id: '0e741fd8-43f7-4f4d-9740-a8498bead408',
        target: TARGET.AFFILIATE,
        sscid: urlParams[URL_SEARCH_PARAM.SS_CID]?.toString(),
        referrer: Referrer.SHARE_SALE_AFFILIATE,
    };
}
function extractUtmMediumParams(urlParams) {
    return {
        referrer: urlParams[URL_SEARCH_PARAM.UTM_SOURCE]?.toString(),
        keyword: !!urlParams[URL_SEARCH_PARAM.KEYWORD],
        adset_name: urlParams[URL_SEARCH_PARAM.AD_SET_NAME]?.toString(),
        ad_name: urlParams[URL_SEARCH_PARAM.AD_NAME]?.toString(),
        campaign_name: urlParams[URL_SEARCH_PARAM.UTM_CAMPAIGN]?.toString(),
        utm_content: urlParams[URL_SEARCH_PARAM.UTM_CONTENT]?.toString(),
        utm_term: urlParams[URL_SEARCH_PARAM.UTM_TERM]?.toString(),
        utm_medium: urlParams[URL_SEARCH_PARAM.UTM_MEDIUM]?.toString(),
    };
}
function extractUtmSourceParams(urlParams) {
    let result = {};
    const utmSource = urlParams[URL_SEARCH_PARAM.UTM_SOURCE];
    if (utmSource) {
        switch (utmSource) {
            case UTM_SOURCE_VALUES.GOOGLE:
                result.referrer = Referrer.SEM;
                break;
            case UTM_SOURCE_VALUES.GDN:
                result.referrer = Referrer.GDN;
                result.keyword = true;
                result.matchtype = true;
                break;
            case UTM_SOURCE_VALUES.FACEBOOK:
                result.referrer = Referrer.FACEBOOK;
                result.keyword = true;
                break;
            case UTM_SOURCE_VALUES.BING:
                result.referrer = Referrer.BING;
                break;
        }
    }
    return result;
}
function readQueryParams(data, urlParams) {
    let result = { ...data };
    let extractedData = {};
    if (urlParams[URL_SEARCH_PARAM.TRANS]) {
        extractedData = extractTransParams(urlParams);
    }
    else if (urlParams[URL_SEARCH_PARAM.IR_CLICKED] ||
        urlParams[URL_SEARCH_PARAM.MP_ID]) {
        extractedData = extractIRClickedParams(urlParams);
    }
    else if (urlParams[URL_SEARCH_PARAM.REF]) {
        extractedData = extractRefParams(urlParams);
        extractedData['amp_user_property'] = {
            initial_ref: urlParams[URL_SEARCH_PARAM.REF]?.toString(),
        };
    }
    else if (urlParams[URL_SEARCH_PARAM.SS_CID]) {
        extractedData = extractSsCidParams(urlParams);
    }
    else if (urlParams[URL_SEARCH_PARAM.UTM_MEDIUM] &&
        urlParams[URL_SEARCH_PARAM.UTM_MEDIUM] === UTM_MEDIUM_VALUES.CPC) {
        extractedData = {
            ...extractUtmMediumParams(urlParams),
            ...extractUtmSourceParams(urlParams),
        };
    }
    else if (urlParams[URL_SEARCH_PARAM.UTM_SOURCE] &&
        urlParams[URL_SEARCH_PARAM.UTM_SOURCE] === UTM_SOURCE_VALUES.BLOG) {
        result.referrer = Referrer.BLOG;
        result.utm_medium = urlParams[URL_SEARCH_PARAM.UTM_MEDIUM]?.toString();
        result.campaign_name = urlParams[URL_SEARCH_PARAM.UTM_CAMPAIGN]?.toString();
        result.utm_content = urlParams[URL_SEARCH_PARAM.UTM_CONTENT]?.toString();
        result.utm_term = urlParams[URL_SEARCH_PARAM.UTM_TERM]?.toString();
    }
    else if (urlParams[URL_SEARCH_PARAM.UTM_SOURCE] &&
        urlParams[URL_SEARCH_PARAM.UTM_SOURCE].toString().toLowerCase() ===
            UTM_SOURCE_VALUES.YOUTUBE &&
        (urlParams[URL_SEARCH_PARAM.UTM_MEDIUM].toString().toLowerCase() ===
            UTM_MEDIUM_VALUES.CPV ||
            urlParams[URL_SEARCH_PARAM.UTM_MEDIUM].toString().toLowerCase() ===
                UTM_MEDIUM_VALUES.SOCIAL)) {
        result.referrer = Referrer.YOUTUBE;
    }
    else if (urlParams[URL_SEARCH_PARAM.REFERRER]) {
        result.referrer = urlParams[URL_SEARCH_PARAM.REFERRER]?.toString();
    }
    return { ...result, ...extractedData };
}
function getUTMParams(params) {
    const utmParams = {
        utm_source: params?.['utm_source'] || 'na',
        utm_medium: params?.['utm_medium'] || 'na',
        utm_campaign: params?.['utm_campaign'] || 'na',
        utm_term: params?.['utm_term'] || 'na',
        utm_content: params?.['utm_content'] || 'na',
    };
    return utmParams;
}
function getClickId(data, urlParameters) {
    let clickId = 'na';
    if (data.click_id) {
        clickId = data.click_id;
    }
    else if (urlParameters) {
        if (urlParameters[URL_SEARCH_PARAM.IR_CLICKED]) {
            clickId = urlParameters[URL_SEARCH_PARAM.IR_CLICKED].toString();
        }
        else if (urlParameters[URL_SEARCH_PARAM.SS_CID]) {
            clickId = urlParameters[URL_SEARCH_PARAM.SS_CID].toString();
        }
        else if (urlParameters[URL_SEARCH_PARAM.GCL_ID]) {
            clickId = urlParameters[URL_SEARCH_PARAM.GCL_ID].toString();
        }
        else if (urlParameters[URL_SEARCH_PARAM.FB_CL_ID]) {
            clickId = urlParameters[URL_SEARCH_PARAM.FB_CL_ID].toString();
        }
        else if (urlParameters[URL_SEARCH_PARAM.MS_CLK_ID]) {
            clickId = urlParameters[URL_SEARCH_PARAM.MS_CLK_ID].toString();
        }
    }
    return clickId;
}
function getOfferId(data, urlParameters) {
    let offer_id = 'na';
    if (data.offer_id) {
        offer_id = data.offer_id;
    }
    return offer_id;
}
function getPartnerId(data, urlParameters) {
    let partner_id = 'na';
    if (data.partner_id) {
        partner_id = data.partner_id;
    }
    else if (urlParameters) {
        if (urlParameters[URL_SEARCH_PARAM.USER_REFERRER]) {
            partner_id = urlParameters[URL_SEARCH_PARAM.USER_REFERRER].toString();
        }
    }
    return partner_id;
}
function getParsedUrlParams() {
    let urlParameters;
    const params = Cookies.get(window.btoa(COOKIE_KEYS.QUERY_PARAMS));
    if (params) {
        const newParam = params.split('?');
        urlParameters = QueryString.parse(newParam[1]);
    }
    else {
        const searchUrl = window.location.search.split('?');
        urlParameters = QueryString.parse(searchUrl[1]);
    }
    return urlParameters;
}
export function getMetaProerties() {
    let urlParameters = getParsedUrlParams();
    let result = {};
    result.referrer = AnalyticsUtils.getReferrer();
    if (urlParameters[URL_SEARCH_PARAM.REF] ||
        urlParameters[URL_SEARCH_PARAM.SS_CID] ||
        urlParameters[URL_SEARCH_PARAM.FB_CL_ID] ||
        urlParameters[URL_SEARCH_PARAM.UTM_SOURCE] ||
        urlParameters[URL_SEARCH_PARAM.GCL_ID] ||
        urlParameters[URL_SEARCH_PARAM.IR_CLICKED] ||
        urlParameters[URL_SEARCH_PARAM.MP_ID] ||
        urlParameters[URL_SEARCH_PARAM.REFERRER] ||
        urlParameters[URL_SEARCH_PARAM.MS_CLK_ID]) {
        result = { ...result, ...readQueryParams(result, urlParameters) };
    }
    const attribute = {
        referrer: result.referrer,
        channel: AnalyticsUtils.toSnakeCase(AnalyticsUtils.getChannel()),
        click_id: getClickId(result, urlParameters),
        offer_id: getOfferId(result, urlParameters),
        partner_id: getPartnerId(result, urlParameters),
        ...getUTMParams(urlParameters),
    };
    const data = {
        attribute: AnalyticsUtils.toLowerCaseObject(attribute),
    };
    if (urlParameters) {
        data['qs'] = urlParameters;
    }
    return data;
}
function checkParameters(data, domain, skipMeta) {
    data['amp_event_property'] = {};
    data['amp_user_property'] = {};
    let result = { ...data };
    result.referrer = AnalyticsUtils.getReferrer();
    if (domain === DOMAIN.LANDING_PAGE) {
        result.landing_page = window.location.href;
    }
    let urlParameters = getParsedUrlParams();
    if (urlParameters[URL_SEARCH_PARAM.REF] ||
        urlParameters[URL_SEARCH_PARAM.SS_CID] ||
        urlParameters[URL_SEARCH_PARAM.FB_CL_ID] ||
        urlParameters[URL_SEARCH_PARAM.UTM_SOURCE] ||
        urlParameters[URL_SEARCH_PARAM.GCL_ID] ||
        urlParameters[URL_SEARCH_PARAM.IR_CLICKED] ||
        urlParameters[URL_SEARCH_PARAM.MP_ID] ||
        urlParameters[URL_SEARCH_PARAM.REFERRER] ||
        urlParameters[URL_SEARCH_PARAM.MS_CLK_ID]) {
        result = readQueryParams(result, urlParameters);
    }
    if (!skipMeta) {
        result['meta'] = {
            ...AnalyticsUtils.commonRudderStackEventProperties(),
            ...getPageProperties(),
            ...getMetaProerties(),
        };
        result['rudder_track_id'] = AnalyticsUtils.getAnonymousId();
    }
    if (window.location.href.includes('coupon=') &&
        window.location.href.includes('/register')) {
        const searchUrl = window.location.search.split('?');
        urlParameters = QueryString.parse(searchUrl[1]);
        result.coupon = urlParameters[URL_SEARCH_PARAM.COUPON]?.toString();
    }
    return result;
}
function getReferralChannel() {
    const cookieParams = Cookies.get(window.btoa(COOKIE_KEYS.QUERY_PARAMS));
    const searchString = window.location.search || cookieParams;
    const queryParams = searchString && searchString.charAt(0) === '?'
        ? searchString.substring(1)
        : searchString;
    const INTERNAL_DOMAINS = /invideo|videocreek|imagetovideo|kizoa|localhost/;
    const SEARCH_ENGINES = /google|bing|yahoo/;
    const SOCIAL_MEDIA_PLATFORMS = /facebook|instagram|youtube/;
    const UTM_MEDIUM = /cpc/;
    if (queryParams) {
        const params = QueryString.parse(queryParams);
        const referralValues = {
            Channel: '',
            utm_source: params[URL_SEARCH_PARAM.UTM_SOURCE]?.toString(),
            utm_medium: params[URL_SEARCH_PARAM.UTM_MEDIUM]?.toString(),
            utm_campaign: params[URL_SEARCH_PARAM.UTM_CAMPAIGN]?.toString(),
            utm_term: params[URL_SEARCH_PARAM.UTM_TERM]?.toString(),
            utm_content: params[URL_SEARCH_PARAM.UTM_CONTENT]?.toString(),
            referrer: params[URL_SEARCH_PARAM.REFERRER]?.toString() ||
                document.referrer?.toString(),
            Matchtype: params[URL_SEARCH_PARAM.MATCH_TYPE]?.toString(),
            Creative: params[URL_SEARCH_PARAM.CREATIVE]?.toString(),
            Placement: params[URL_SEARCH_PARAM.PLACEMENT]?.toString(),
            Campaign_id: params[URL_SEARCH_PARAM.CAMPAIGN_ID]?.toString(),
            Adset_id: params[URL_SEARCH_PARAM.AD_SET_ID]?.toString(),
            Ad_id: params[URL_SEARCH_PARAM.AD_ID]?.toString(),
            ref: params[URL_SEARCH_PARAM.REF]?.toString(),
            msclkid: params[URL_SEARCH_PARAM.MS_CLK_ID]?.toString(),
            fbclid: params[URL_SEARCH_PARAM.FB_CL_ID]?.toString(),
        };
        if (referralValues.utm_source?.match(SEARCH_ENGINES) &&
            referralValues.utm_medium?.match(UTM_MEDIUM) &&
            referralValues.utm_campaign?.includes('brand')) {
            referralValues.Channel = CHANNEL.BRANDED_PAID_SEARCH;
        }
        else if (referralValues.utm_source?.match(SEARCH_ENGINES) &&
            referralValues.utm_medium?.match(UTM_MEDIUM) &&
            referralValues.Placement &&
            referralValues.Placement === 'd') {
            referralValues.Channel = CHANNEL.DISPLAY;
        }
        else if (referralValues.utm_source?.match(SEARCH_ENGINES) &&
            referralValues.utm_medium?.match(UTM_MEDIUM) &&
            referralValues.Placement?.match(/ytv|yts/gi)) {
            referralValues.Channel = CHANNEL.PAID_YOUTUBE;
        }
        else if (referralValues.utm_source?.match(SEARCH_ENGINES) &&
            referralValues.utm_medium?.match(UTM_MEDIUM)) {
            referralValues.Channel = CHANNEL.PAID_SEARCH;
        }
        else if (referralValues.utm_source?.match(/facebook|fb|instagram/) &&
            referralValues.utm_medium?.match(UTM_MEDIUM)) {
            referralValues.Channel = CHANNEL.PAID_SOCIAL;
        }
        else if (referralValues.referrer?.match(SEARCH_ENGINES)) {
            referralValues.Channel = CHANNEL.ORGANIC_SEARCH;
        }
        else if (referralValues.utm_medium?.match(/email/)) {
            referralValues.Channel = CHANNEL.EMAIL;
        }
        else if (!!referralValues.ref) {
            referralValues.Channel = CHANNEL.AFFILIATE;
        }
        else if (referralValues.referrer?.match(SOCIAL_MEDIA_PLATFORMS)) {
            referralValues.Channel = CHANNEL.ORGANIC_SOCIAL;
        }
        else if (!!referralValues.referrer &&
            !referralValues.referrer.match(INTERNAL_DOMAINS)) {
            referralValues.Channel = CHANNEL.REFERRAL;
        }
        else if (params[URL_SEARCH_PARAM.USER_REFERRER]) {
            referralValues.Channel = CHANNEL.USER_REFERRAL;
        }
        return referralValues;
    }
    if (document.referrer) {
        const documentReferrer = document.referrer;
        const referralData = {
            Channel: '',
            referrer: document.referrer,
        };
        if (documentReferrer.match(SEARCH_ENGINES)) {
            referralData.Channel = CHANNEL.ORGANIC_SEARCH;
        }
        else if (documentReferrer.match(SOCIAL_MEDIA_PLATFORMS)) {
            referralData.Channel = CHANNEL.ORGANIC_SOCIAL;
        }
        else if (!!documentReferrer &&
            !documentReferrer.match(INTERNAL_DOMAINS)) {
            referralData.Channel = CHANNEL.REFERRAL;
        }
        return referralData;
    }
    return {};
}
function sanitizeParams(params = PARAMS_BLACKLIST) {
    let url = window.location.href.split('?')[0] + '?';
    let searchParams = window.location.search.substring(1);
    if (!searchParams.length) {
        return window.location.href;
    }
    const parsedSearchParams = QueryString.parse(searchParams);
    Object.entries(parsedSearchParams).forEach(e => {
        if (!params.includes(e[0].toLowerCase())) {
            url = url + e[0] + '=' + e[1] + '&';
        }
    });
    return url.substring(0, url.length - 1);
}
export function getPageProperties() {
    const userPageProperties = {};
    if (!!AnalyticsUtils.getPage()) {
        userPageProperties['type'] =
            AnalyticsUtils.toSnakeCase(AnalyticsUtils.getPage());
    }
    userPageProperties['url'] = window.location.href;
    userPageProperties['source'] = sanitizeParams();
    return { page: userPageProperties };
}
export { checkParameters, getReferralChannel, sanitizeParams };
